module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    class: _vm.fullscreen ? 'mt-5' : '',
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-xs0": _vm.fullscreen,
      "xs12": _vm.fullscreen,
      "offset-md3": _vm.fullscreen,
      "md6": _vm.fullscreen
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-4 elevation-3"
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn-toggle', {
    staticClass: "hidden-sm-and-up mb-3",
    attrs: {
      "mandatory": ""
    },
    model: {
      value: (_vm.userType),
      callback: function($$v) {
        _vm.userType = $$v
      },
      expression: "userType"
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%",
      "min-height": "30px"
    },
    attrs: {
      "block": "",
      "value": "professor"
    }
  }, [_c('span', [_vm._v("Professor/Aluno da UNIFEBE")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%",
      "min-height": "30px"
    },
    attrs: {
      "block": "",
      "value": "visitante"
    }
  }, [_c('span', [_vm._v("Visitante (público externo)")])])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "grow": "",
      "centered": ""
    },
    model: {
      value: (_vm.userType),
      callback: function($$v) {
        _vm.userType = $$v
      },
      expression: "userType"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "hidden-xs-only",
    attrs: {
      "light": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "primary"
    }
  }), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#professor"
    }
  }, [_vm._v("\n                                            Professor/Aluno da UNIFEBE\n                                        ")]), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#visitante"
    }
  }, [_vm._v("\n                                            Visitante (público externo)\n                                        ")])], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "professor"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v("Informe abaixo seu código e senha de acesso da Central Acadêmica.")])], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "visitante"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v("Informe abaixo seu CPF/Passaporte e sua senha de acesso."), _c('br'), _vm._v("\n                                                     Ou clique em "), _c('strong', [_vm._v("Cadastrar-se")]), _vm._v(" caso ainda não tenha cadastro de visitante.")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": _vm.useridLabel,
      "data-vv-as": "Código",
      "data-vv-name": "userid",
      "prepend-icon": "person",
      "errors": _vm.vErrors.collect('userid'),
      "required": ""
    },
    model: {
      value: (_vm.credentials.userid),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "userid", $$v)
      },
      expression: "credentials.userid"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Senha",
      "data-vv-as": "Senha",
      "data-vv-name": "password",
      "prepend-icon": "security",
      "type": "password",
      "errors": _vm.vErrors.collect('password'),
      "required": ""
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary",
      "dark": "",
      "large": ""
    }
  }, [_vm._v("Entrar")]), _vm._v(" "), (_vm.userType == 'visitante') ? _c('v-btn', {
    attrs: {
      "type": "button",
      "color": "info",
      "dark": "",
      "large": "",
      "to": "/ouvinte/cadastrar"
    }
  }, [_vm._v("Cadastrar-se")]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "value": true,
      "error": ""
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 1), _vm._v(" "), (_vm.showActions) ? _c('v-card-actions', [_vm._t("actions")], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('fullscreen-spinner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18091274"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 242
// module chunks = 0